export default function HomePage() {
    return (
        <div style={{ padding: "2rem 10rem 2rem 10rem" }}>
            <h1>You weren't meant to get here.</h1>
            <p>
                This website is intended for management of your roleplay HUD.
                
                Please click your HUD's menu button and click "Configure" to get started.
            </p>
        </div>
    );
}